export default [
  { value: true, key: "dependentCoverages.datatable.student.yes" },
  { value: false, key: "dependentCoverages.datatable.student.no" },
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/dependents/coverages/enums/dependentCoverageStudent.js